import { defineComponent, ref } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { useInterceptorStore } from '@/store/modules/interceptor';
import { Button } from '@yellowcard/components-library-vue3';
import { numberFormat, getChannelLabel, getChannelType } from '@/utils/helpers';
import router, { RoutePaths } from '@/router';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import BuyOrderSummaryComponent from '@/components/buyCrypto/BuyOrderSummaryComponent.vue';
import SellOrderSummaryComponent from '@/components/sell/SellOrderSummaryComponent.vue';
import { storeToRefs } from 'pinia';
import { TransactTypes } from '@/types/transact';
import { useAuthStore } from '@/store/modules/auth';
import { AuthTypes } from '@/types/auth';
import { usePaymentStore } from '@/store/modules/payment';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import { PaymentTypes } from '@/types/payment';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import { PayoutAccountsTypes } from '@/types/payout-accounts';
export default defineComponent({
    name: 'OrderSummary',
    computed: {
        TransactTypes() {
            return TransactTypes;
        },
    },
    emits: ['selected'],
    components: {
        LoaderComponent,
        TransactHeader,
        BuyOrderSummaryComponent,
        Button,
        SellOrderSummaryComponent,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedCrypto, selectedCryptoAmount, selectedChannel, usdRate, networkFee, loading, currentStep, txType, } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { currentStep: authCurrentStep, isLoggedIn, standaloneAuthFlow, partnerId, } = storeToRefs(authStore);
        const paymentStore = usePaymentStore();
        const { currentStep: paymentCurrentStep } = storeToRefs(paymentStore);
        const payoutAccountsStore = usePayoutAccountsStore();
        const { currentStep: payoutAccountsStep, selectedPayoutMethod, fromTransaction, payoutAccounts, } = storeToRefs(payoutAccountsStore);
        const interceptorStore = useInterceptorStore();
        const { showBackNavigation } = storeToRefs(interceptorStore);
        const showRateAlert = ref(false);
        const onContinueClicked = async () => {
            trackEvent(MIXPANEL_EVENTS.ACCEPT_QUOTE, {
                logged_in: isLoggedIn.value,
                partner: partnerId.value,
                payment_method: getChannelLabel(selectedChannel.value),
            });
            if (!isLoggedIn.value) {
                await router.push('/auth');
                standaloneAuthFlow.value = false;
                authCurrentStep.value = AuthTypes.AuthSteps.AUTH_1;
                return;
            }
            switch (txType.value) {
                case TransactTypes.TransactionType.BUY: {
                    paymentCurrentStep.value = PaymentTypes.PaymentSteps.PAYMENT_1;
                    await router.push(RoutePaths.Payment);
                    return;
                }
                case TransactTypes.TransactionType.SELL: {
                    fromTransaction.value = true;
                    selectedPayoutMethod.value = getChannelType(selectedChannel.value);
                    payoutAccountsStep.value = payoutAccounts.value.filter(account => account.accountType === selectedPayoutMethod.value).length
                        ? PayoutAccountsTypes.PayoutComponents.ManagePayouts
                        : PayoutAccountsTypes.PayoutComponents.FormSelect;
                    await router.push(RoutePaths.PayoutAccounts);
                    return;
                }
                default:
                    paymentCurrentStep.value = PaymentTypes.PaymentSteps.PAYMENT_1;
            }
        };
        const goBack = async () => {
            // need to reset fees and calculatedCryptoAmount
            transactionsStore.resetFees();
            currentStep.value = TransactTypes.TransactSteps.BUY_2;
        };
        return {
            selectedCrypto,
            selectedCryptoAmount,
            numberFormat,
            usdRate,
            networkFee,
            showRateAlert,
            loading,
            onContinueClicked,
            goBack,
            isLoggedIn,
            txType,
            showBackNavigation,
        };
    },
});
